/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { useCommandPaletteRegistryCurrentAttribution } from '@jira/compal__command-palette/src/controllers/command-palette/index.tsx';

export const JiraCommandPaletteErrorBoundary = ({
	id,
	children,
}: {
	id: string;
	children: React.ReactNode | React.ReactNode[];
}): React.JSX.Element => {
	const [data] = useCommandPaletteRegistryCurrentAttribution();
	return (
		<JSErrorBoundary
			id={id}
			packageName="jiraCommandPaletteIntegration"
			fallback="unmount"
			teamName={data?.registryData?.teamName || 'deliveroo'}
			attributes={data?.analyticsAttributes}
		>
			{children}
		</JSErrorBoundary>
	);
};
